import { StateCreator } from "zustand";

interface AuthUser {
  authUser: string;
  userInfo: {
    userUuid: string;
    userEmail: string;
    userName: string;
    userSurName: string;
    userSocialName: string | null;
    userLogoUrl: string;
    userStatus: true;
    userGroupType: number;
    userGroupName: string;
    userGroupStatus: true;
    userGroupInfo: [];
  };
}

export interface AuthSlice {
  authUserZustand: AuthUser | null;

  setAuthUserZustand: (data: { authUser: AuthUser }) => void;
  removeAuthUserZustand: () => void;
}

export const createAuthSlice: StateCreator<AuthSlice> = (
  set: any,
  get: any
) => {
  return {
    authUserZustand: null,

    setAuthUserZustand: (data: { authUser: AuthUser }) => {
      set({
        authUserZustand: data,
      });
    },

    removeAuthUserZustand: () => {
      set({
        authUserZustand: null,
      });
    },
  };
};
